import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  return (
    <div className="auth-container">
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '6rem', fontWeight: 'bold', color: 'var(--color-text-secondary)', marginBottom: '1rem' }}>
          404
        </div>
        <h1 style={{ marginBottom: '0.5rem' }}>{t('errors.notFound')}</h1>
        <p style={{ color: 'var(--color-text-secondary)', marginBottom: '2rem' }}>
          The page you are looking for does not exist.
        </p>
        <Link
          to={isAuthenticated ? '/lists' : '/login'}
          className="btn btn-primary"
        >
          {isAuthenticated ? t('nav.lists') : t('auth.login')}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
